import { EventResponse } from 'misc/api/hooks/event.types'
import { GuestType, Party } from 'misc/api/types'

export const filterGuests = <
  T extends EventResponse['fields'] | Party['guests']
>(
  guestTypeArray: T,
  guestType: GuestType
): T => guestTypeArray.filter(({ guest_type }) => guest_type === guestType) as T
